/**
 * Fan MI event: gift-with-purchase (GWP)
 * - Quick view / PDP add: main + gift in one /cart/add.js request with paired line properties.
 * - After cart changes: remove or reduce gift lines when their bundle has no / insufficient main qty.
 */
(function () {
  var STORAGE_KEY = 'fan_mi_gwp_pending';
  var SYNC_FLAG = '__fanMiGwpSyncing';
  var DEBUG_ON = /(?:\?|&)gwp_debug=1(?:&|$)/.test(window.location.search);
  try {
    window.__fanMiGwpLoaded = true;
    window.__fanMiGwpLastStatus = window.__fanMiGwpLastStatus || { step: 'idle', at: Date.now() };
  } catch (errInit) {}

  function debugLog() {
    if (!DEBUG_ON || !window.console || !console.log) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[fan-mi-gwp]');
    try {
      console.log.apply(console, args);
    } catch (err) {}
  }

  function debugError() {
    if (!window.console || !console.error) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[fan-mi-gwp]');
    try {
      console.error.apply(console, args);
    } catch (err) {}
  }

  function readPending() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || typeof o !== 'object') return null;
      if (o.expiresAt && Date.now() > o.expiresAt) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return o;
    } catch (e) {
      return null;
    }
  }

  function writePending(data) {
    try {
      data.expiresAt = Date.now() + 3600000;
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function clearPending() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function clearGwpModalAttrs(modal) {
    if (!modal) return;
    modal.removeAttribute('data-gwp-main-product-id');
    modal.removeAttribute('data-gwp-gift-variant-id');
  }

  function safeDocumentDispatch(evt) {
    try {
      document.dispatchEvent(evt);
    } catch (err) {}
  }

  function safeElementDispatch(el, evt) {
    if (!el) return;
    try {
      el.dispatchEvent(evt);
    } catch (err) {}
  }

  function notifyGloboPreorderCartUpdated() {
    if (!(window && window.Globo && window.Globo.Preorder && window.GloboPreorderParams)) return;
    safeDocumentDispatch(new CustomEvent('globo.preorder.update.cart'));
  }

  /** 弹窗 DOM 优先：避免 sessionStorage 被关弹窗/隐私模式清空后快速查看里加购丢失礼品 */
  function resolveGwpPairing(el) {
    var modal = el && el.closest && el.closest('.modal[id^="modal-quick-view-"]');
    var mid = modal && modal.getAttribute('data-gwp-main-product-id');
    var gid = modal && modal.getAttribute('data-gwp-gift-variant-id');
    if (mid && gid) {
      debugLog('pairing from modal', { mainProductId: String(mid).trim(), giftVariantId: String(gid).trim() });
      return { mainProductId: String(mid).trim(), giftVariantId: String(gid).trim() };
    }
    debugLog('pairing from sessionStorage fallback');
    return readPending();
  }

  function serializeProductForm(innerForm) {
    if (typeof Form !== 'undefined' && Form.serialize) {
      return Form.serialize(innerForm);
    }
    var fd = new FormData(innerForm);
    var out = {
      quantity: Math.max(1, parseInt(String(fd.get('quantity') || '1'), 10) || 1),
    };
    var vid = fd.get('id');
    if (vid != null && vid !== '') out.id = vid;
    var sp = fd.get('selling_plan');
    if (sp != null && sp !== '') out.selling_plan = sp;
    var props = {};
    fd.forEach(function (val, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (m) props[m[1]] = val;
    });
    if (Object.keys(props).length) out.properties = props;
    return out;
  }

  function cartJsonUrl() {
    if (window.routes && window.routes.cartUrl) {
      var u = window.routes.cartUrl;
      return u.indexOf('.js') !== -1 ? u : u + '.js';
    }
    return '/cart.js';
  }

  function cartUpdateJsonUrl() {
    if (window.routes && window.routes.cartUrl) {
      var u = String(window.routes.cartUrl).replace(/\/$/, '');
      return u + '/update.js';
    }
    return '/cart/update.js';
  }

  function newBundleId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return 'gwp-' + crypto.randomUUID();
    }
    return 'gwp-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function productIdFromProductForm(formEl) {
    if (!formEl || !formEl.id) return null;
    var m = /^product-form-(?:quick-buy|main)-(\d+)-/.exec(formEl.id);
    return m ? m[1] : null;
  }

  function isDisabledControl(el) {
    return !!(el && (el.disabled || el.hasAttribute('disabled')));
  }

  /**
   * 快速查看异步插入后，点击可能在子节点上；部分主题/区块的加购按钮没有 data-action（见 featured-product）。
   * @param {{ broad?: boolean }} opts broad=true 时同时匹配 .product-form__add-button（仅用于 quick-view modal 内委托）
   */
  function findAddToCartButtonFromEvent(e, opts) {
    opts = opts || {};
    var broad = !!opts.broad;

    function tryFromNode(root) {
      if (!root || !root.closest) return null;
      var hit = root.closest('[data-action="add-to-cart"]');
      if (hit && !isDisabledControl(hit)) return hit;
      if (broad) {
        hit = root.closest('button.product-form__add-button[type="submit"]');
        if (hit && !isDisabledControl(hit)) return hit;
      }
      return null;
    }

    if (e.target) {
      var a = tryFromNode(e.target);
      if (a) return a;
    }
    var path = typeof e.composedPath === 'function' ? e.composedPath() : null;
    if (!path || !path.length) return null;
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (!n || n.nodeType !== 1) continue;
      if (n.matches && n.matches('[data-action="add-to-cart"]') && !isDisabledControl(n)) return n;
      if (broad && n.matches && n.matches('button.product-form__add-button[type="submit"]') && !isDisabledControl(n)) return n;
      var b = tryFromNode(n);
      if (b) return b;
    }
    return null;
  }

  /** 点击是否发生在快速查看弹窗内（含 composedPath） */
  function eventInQuickViewModal(e) {
    if (!e || !e.target) return false;
    if (e.target.closest && e.target.closest('.modal[id^="modal-quick-view-"]')) return true;
    var path = typeof e.composedPath === 'function' ? e.composedPath() : null;
    if (!path) return false;
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (n && n.matches && n.matches('.modal[id^="modal-quick-view-"]')) return true;
    }
    return false;
  }

  /**
   * 弹窗 HTML 注入后，加购按钮有时不在 form 的祖先链上（或仅用 form="" 关联）。
   * 在 product-form / 当前 quick-view modal / section 内解析真正的 cart form。
   */
  function resolveCartAddForm(btn, productForm) {
    var f;
    if (productForm) {
      f = productForm.querySelector('form[action*="/cart/add"]');
      if (f) return f;
    }
    f = btn.closest('form[action*="/cart/add"]');
    if (f) return f;
    var formAttr = btn.getAttribute && btn.getAttribute('form');
    if (formAttr) {
      f = document.getElementById(formAttr);
      if (f && f.tagName === 'FORM' && f.action && String(f.action).indexOf('/cart/add') !== -1) return f;
    }
    var modal = btn.closest('.modal[id^="modal-quick-view-"]');
    if (modal) {
      f = modal.querySelector('form[action*="/cart/add"]');
      if (f) return f;
    }
    var sec = btn.closest('[data-section-type="product-quick-view"]');
    if (sec) {
      f = sec.querySelector('form[action*="/cart/add"]');
      if (f) return f;
    }
    return null;
  }

  /**
   * 多规格时 Theme 的 VariantPicker 用内存里的 selectedVariant 更新 UI，部分场景下 Form.serialize
   * 拿不到 name="id"（快速查看片段、no-js select 被禁用等）。优先读 variant-picker，再回落表单控件与 script[data-variant]。
   */
  function enrichMainPayloadVariantId(innerForm, mainPayload) {
    var pf = innerForm.closest('product-form');
    var picker = pf && pf.querySelector('variant-picker');

    if (picker && picker.selectedVariant && picker.selectedVariant.id) {
      mainPayload.id = String(picker.selectedVariant.id).trim();
      return mainPayload;
    }

    if (mainPayload.id) return mainPayload;

    var el = innerForm.elements.namedItem('id');
    if (el && !el.disabled && el.value != null && String(el.value).trim() !== '') {
      mainPayload.id = String(el.value).trim();
      return mainPayload;
    }

    var pid = productIdFromProductForm(innerForm);
    if (pid) {
      var ps = innerForm.querySelector('#product-select-' + pid);
      if (ps && !ps.disabled && ps.value != null && String(ps.value).trim() !== '') {
        mainPayload.id = String(ps.value).trim();
        return mainPayload;
      }
    }

    var q = innerForm.querySelector('[name="id"]:not([disabled])');
    if (q && q.value != null && String(q.value).trim() !== '') {
      mainPayload.id = String(q.value).trim();
      return mainPayload;
    }

    var scr = picker && picker.querySelector('script[data-variant]');
    if (!scr && pf) scr = pf.querySelector('variant-picker script[data-variant]');
    if (scr && scr.textContent) {
      try {
        var v = JSON.parse(scr.textContent);
        if (v && v.id) mainPayload.id = String(v.id).trim();
      } catch (err) {}
    }
    return mainPayload;
  }

  function isQuickViewModal(el) {
    return !!(el && el.closest && el.closest('.modal[id^="modal-quick-view-"]'));
  }

  function isProductPageForm(formEl) {
    return window.theme && window.theme.pageType === 'product' && !isQuickViewModal(formEl);
  }

  /** window 捕获早于 document，避免其它脚本在 document 上 stopPropagation 导致我们收不到点击 */
  window.addEventListener(
    'click',
    function (e) {
      var t = e.target && e.target.closest && e.target.closest('[data-secondary-action="open-quick-view"]');
      if (!t) return;
      var modalId = t.getAttribute('aria-controls');
      var modal = modalId && document.getElementById(modalId);
      if (!modal || modal.id.indexOf('modal-quick-view-') !== 0) return;

      if (t.getAttribute('data-gwp-enabled') === 'true' && t.closest('[data-section-type="fan-mi-event-product"]')) {
        var mainId = String(t.getAttribute('data-gwp-main-product-id') || '');
        var giftVid = String(t.getAttribute('data-gwp-gift-variant-id') || '');
        writePending({ mainProductId: mainId, giftVariantId: giftVid });
        modal.setAttribute('data-gwp-main-product-id', mainId);
        modal.setAttribute('data-gwp-gift-variant-id', giftVid);
      } else {
        clearGwpModalAttrs(modal);
      }
    },
    true
  );

  /**
   * 在弹窗「外壳」上捕获点击：inner 被 replaceChildren 替换后仍有效，避免仅依赖 window 时序/拦截链丢失。
   */
  function attachQuickViewModalGwpCapture(modal) {
    if (!modal || modal.id.indexOf('modal-quick-view-') !== 0 || modal.__fanMiGwpModalGwpCapture) return;
    modal.__fanMiGwpModalGwpCapture = true;
    modal.addEventListener(
      'click',
      function (e) {
        if (e.__fanMiGwpHandled) return;
        var btn = findAddToCartButtonFromEvent(e, { broad: true });
        if (!btn || !modal.contains(btn)) return;
        try {
          window.__fanMiGwpLastStatus = { step: 'qv_modal_capture', at: Date.now() };
        } catch (err1) {}
        var productForm = btn.closest('product-form') || null;
        var innerForm = resolveCartAddForm(btn, productForm);
        if (!innerForm) {
          try {
            window.__fanMiGwpLastStatus = { step: 'skip', reason: 'qv_modal_no_cart_form', at: Date.now() };
          } catch (err2) {}
          debugError('quick-view modal: cart add form not found', {
            modalId: modal.id,
            btnTag: btn.tagName,
            btnClass: btn.className,
            hasProductForm: !!productForm,
          });
          return;
        }
        if (!productForm) productForm = innerForm.closest('product-form') || null;
        if (DEBUG_ON) {
          console.log('[fan-mi-gwp] quick-view modal capture', { formId: innerForm.id, hasProductForm: !!productForm });
        }
        runGwpBundleAdd(e, innerForm, productForm, btn);
      },
      true
    );
  }

  function attachQuickViewCloseObserver(modal) {
    if (!modal || modal.__fanMiGwpAriaObs) return;
    modal.__fanMiGwpAriaObs = true;
    var prevAria = modal.getAttribute('aria-hidden');
    var obs = new MutationObserver(function () {
      var now = modal.getAttribute('aria-hidden');
      if (now === 'true' && prevAria === 'false') {
        clearPending();
        clearGwpModalAttrs(modal);
      }
      prevAria = now;
    });
    obs.observe(modal, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function initQuickViewObservers() {
    document.querySelectorAll('.modal[id^="modal-quick-view-"]').forEach(function (m) {
      attachQuickViewCloseObserver(m);
      attachQuickViewModalGwpCapture(m);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickViewObservers);
  } else {
    initQuickViewObservers();
  }
  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) {
      ev.target.querySelectorAll('.modal[id^="modal-quick-view-"]').forEach(function (m) {
        attachQuickViewCloseObserver(m);
        attachQuickViewModalGwpCapture(m);
      });
    }
  });

  function wrapFetchForCartSync() {
    if (window.__fanMiGwpFetchWrapped) return;
    window.__fanMiGwpFetchWrapped = true;
    var orig = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : input && input.url;
      var path = url || '';
      try {
        if (path.indexOf('http') === 0) path = new URL(path).pathname;
      } catch (e) {}
      var p = orig.apply(this, arguments);
      if (path && /\/cart\/(add|change|update|clear)\.js(\?|$)/.test(path)) {
        return p.finally(function () {
          queueMicrotask(function () {
            syncGwpCart().catch(function () {});
          });
        });
      }
      return p;
    };
  }

  function syncGwpCart() {
    if (window[SYNC_FLAG]) return Promise.resolve();
    window[SYNC_FLAG] = true;
    return fetch(cartJsonUrl(), { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var items = cart.items || [];

        // ── 新模式：按 gift variant 分组（_gwp_gift_vid） ──────────────────────
        // 多个主产品可使用同一礼品，礼品合并为一条 line item
        var mainQtyByGiftVid = {};   // { giftVid: totalMainQty }
        var giftLinesByGiftVid = {}; // { giftVid: [{ key, quantity }] }

        // ── 旧模式：按 bundle_id 分组（向前兼容旧购物车数据） ────────────────
        var mainByBundle = {};
        var giftLinesByBundle = {};

        items.forEach(function (line) {
          var props = line.properties || {};
          var role = props._gwp_role;
          if (!role) return;

          var gvid = String(props._gwp_gift_vid || '');
          var bid  = String(props._gwp_bundle_id || '');

          if (role === 'main') {
            if (gvid) {
              mainQtyByGiftVid[gvid] = (mainQtyByGiftVid[gvid] || 0) + line.quantity;
            } else if (bid) {
              mainByBundle[bid] = (mainByBundle[bid] || 0) + line.quantity;
            }
          } else if (role === 'gift') {
            if (gvid) {
              if (!giftLinesByGiftVid[gvid]) giftLinesByGiftVid[gvid] = [];
              giftLinesByGiftVid[gvid].push({ key: line.key, quantity: line.quantity });
            } else if (bid) {
              if (!giftLinesByBundle[bid]) giftLinesByBundle[bid] = [];
              giftLinesByBundle[bid].push({ key: line.key, quantity: line.quantity });
            }
          }
        });

        var updates = {};

        // ── 新模式处理：gift_vid 分组 ─────────────────────────────────────────
        Object.keys(giftLinesByGiftVid).forEach(function (gvid) {
          var mainQty  = mainQtyByGiftVid[gvid] || 0;
          var lines    = giftLinesByGiftVid[gvid];
          var giftTotal = lines.reduce(function (s, x) { return s + x.quantity; }, 0);

          if (mainQty === 0) {
            // 所有主品已移除 → 移除礼品
            lines.forEach(function (L) { updates[L.key] = 0; });
          } else if (lines.length > 1) {
            // 同 variant 存在多条 gift line（理论上 Shopify 已合并，防御处理）
            // 合并到第一条，其余置 0
            var targetQty = Math.min(giftTotal, mainQty);
            updates[lines[0].key] = targetQty;
            for (var j = 1; j < lines.length; j++) {
              updates[lines[j].key] = 0;
            }
          } else if (giftTotal > mainQty) {
            // 礼品超出主品数量 → 收缩
            updates[lines[0].key] = mainQty;
          }
          // giftTotal < mainQty：礼品不足，加购时已确保正确，sync 不主动补充
        });

        // ── 旧模式处理：bundle_id 分组（向前兼容） ───────────────────────────
        Object.keys(giftLinesByBundle).forEach(function (bid) {
          var mainQty = mainByBundle[bid] || 0;
          var lines = giftLinesByBundle[bid];
          var giftTotal = lines.reduce(function (s, x) {
            return s + x.quantity;
          }, 0);

          if (mainQty === 0) {
            lines.forEach(function (L) {
              updates[L.key] = 0;
            });
          } else if (giftTotal > mainQty) {
            var over = giftTotal - mainQty;
            for (var i = lines.length - 1; i >= 0 && over > 0; i--) {
              var L = lines[i];
              var cut = Math.min(L.quantity, over);
              var newQ = L.quantity - cut;
              updates[L.key] = newQ;
              over -= cut;
              L.quantity = newQ;
            }
          }
        });

        if (Object.keys(updates).length === 0) return null;
        return fetch(cartUpdateJsonUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ updates: updates }),
        }).then(function () {
          // cart:refresh 须派发在 document.documentElement（html 元素）上，
          // 因为 Cart.delegateRoot 监听在 html 上，而非 document 上。
          // 直接 dispatch 在 document 上的事件不会冒泡到 html，
          // 导致 _onCartRefresh 永远收不到通知，购物车 UI 不刷新。
          var refreshEvt = new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { scrollToTop: false },
          });
          try {
            document.documentElement.dispatchEvent(refreshEvt);
          } catch (errRefresh) {
            safeDocumentDispatch(refreshEvt);
          }
        });
      })
      .finally(function () {
        window[SYNC_FLAG] = false;
      });
  }

  function buildGwpItems(mainPayload, giftVariantId, qty, bundleId) {
    var giftVid = String(giftVariantId);
    var mainProps = Object.assign({}, mainPayload.properties || {}, {
      _gwp_bundle_id: bundleId,
      _gwp_role: 'main',
      _gwp_gift_vid: giftVid, // 记录主品期望的礼品 variant，供 sync 按 gift_vid 分组
    });
    var mainItem = {
      id: parseInt(mainPayload.id, 10),
      quantity: qty,
      properties: mainProps,
    };
    if (mainPayload.selling_plan) {
      mainItem.selling_plan = mainPayload.selling_plan;
    }
    // gift 行不带 _gwp_bundle_id：相同 gift variant + 相同属性 → Shopify 自动合并为一条
    // 多个主产品用同一个礼品时，购物车里只有一条 gift line item，数量=所有主品之和，
    // 自动折扣（Buy X Get Y）按该合并行生效，全部数量均可享受折扣。
    var giftItem = {
      id: parseInt(giftVariantId, 10),
      quantity: qty,
      properties: {
        _gwp_gift_vid: giftVid,
        _gwp_role: 'gift',
      },
    };
    return { items: [mainItem, giftItem] };
  }

  /**
   * @returns {boolean} true 表示已拦截（主+礼），主题默认加购不会再执行
   */
  function runGwpBundleAdd(e, innerForm, productForm, btn) {
    try {
      window.__fanMiGwpLastStatus = { step: 'start', at: Date.now() };
    } catch (errStatus) {}
    debugLog('runGwpBundleAdd start', { formId: innerForm && innerForm.id, action: innerForm && innerForm.action });
    var pending = resolveGwpPairing(innerForm);
    if (!pending) {
      try {
        window.__fanMiGwpLastStatus = { step: 'skip', reason: 'pending_missing', at: Date.now() };
      } catch (errStatus) {}
      debugLog('skip: pending not found');
      return false;
    }
    var pMain = String(pending.mainProductId || '').trim();
    var pGift = String(pending.giftVariantId || '').trim();
    if (!pMain || !pGift) {
      try {
        window.__fanMiGwpLastStatus = { step: 'skip', reason: 'pending_ids_empty', pending: pending, at: Date.now() };
      } catch (errStatus) {}
      debugLog('skip: pending ids empty', pending);
      return false;
    }

    var pid = productIdFromProductForm(innerForm);
    if (pid && String(pid).trim() !== pMain) {
      // form ID 可解析，但产品 ID 明确不匹配 → 跳过（防止跨产品误触发）
      try {
        window.__fanMiGwpLastStatus = {
          step: 'skip',
          reason: 'product_id_mismatch',
          formProductId: pid,
          pendingMainProductId: pMain,
          at: Date.now(),
        };
      } catch (errStatus) {}
      debugLog('skip: product id mismatch', { formProductId: pid, pendingMainProductId: pMain });
      return false;
    }
    if (!pid) {
      // form ID 格式不符合预期（非 quick-buy / main 模板），但配对数据已存在，继续执行
      debugLog('warn: productIdFromProductForm returned null, proceeding by pairing trust', {
        formId: innerForm && innerForm.id,
        pMain: pMain,
      });
    }

    if (!isQuickViewModal(innerForm) && !isProductPageForm(innerForm)) {
      try {
        window.__fanMiGwpLastStatus = { step: 'skip', reason: 'not_target_form', at: Date.now() };
      } catch (errStatus) {}
      debugLog('skip: not quick-view and not PDP form');
      return false;
    }

    if (!innerForm.reportValidity()) {
      try {
        window.__fanMiGwpLastStatus = { step: 'skip', reason: 'form_invalid', at: Date.now() };
      } catch (errStatus) {}
      debugLog('skip: form invalid');
      return false;
    }

    var qty = Math.max(
      1,
      parseInt(
        innerForm.querySelector('[name="quantity"]') && innerForm.querySelector('[name="quantity"]').value,
        10
      ) || 1
    );
    var mainPayload = enrichMainPayloadVariantId(innerForm, serializeProductForm(innerForm));
    if (!mainPayload.id) {
      try {
        window.__fanMiGwpLastStatus = { step: 'skip', reason: 'main_variant_missing', payload: mainPayload, at: Date.now() };
      } catch (errStatus) {}
      debugLog('skip: mainPayload.id missing after enrich', { payload: mainPayload });
      return false;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    try {
      e.__fanMiGwpHandled = true;
    } catch (errHandled) {}

    var addBtn =
      btn ||
      innerForm.querySelector('[data-action="add-to-cart"]') ||
      innerForm.querySelector('button.product-form__add-button[type="submit"]');
    if (DEBUG_ON) {
      console.log('[fan-mi-gwp] intercept: addBtn resolved (will POST bundle)', {
        fromClickArg: !!btn,
        addBtnFound: !!addBtn,
        addBtnTag: addBtn && addBtn.tagName,
        formId: innerForm.id,
      });
    }
    safeDocumentDispatch(new CustomEvent('theme:loading:start'));
    if (addBtn) addBtn.setAttribute('disabled', 'disabled');

    var bundleId = newBundleId();
    var body = buildGwpItems(mainPayload, pGift, qty, bundleId);
    var addUrl = window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl + '.js' : '/cart/add.js';
    try {
      window.__fanMiGwpLastAddBody = body;
      window.__fanMiGwpLastStatus = { step: 'request_sent', addUrl: addUrl, body: body, at: Date.now() };
    } catch (errStore) {}
    debugLog('intercepted: sending bundled add', body);
    var qvModal = innerForm.closest('.modal[id^="modal-quick-view-"]');

    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        debugLog('add response', { ok: response.ok, status: response.status });
        try {
          window.__fanMiGwpLastStatus = { step: 'response', ok: response.ok, status: response.status, at: Date.now() };
        } catch (errStatus) {}
        safeDocumentDispatch(new CustomEvent('theme:loading:end'));
        if (addBtn) addBtn.removeAttribute('disabled');
        if (!response.ok) {
          return response.json().then(function (err) {
            debugLog('add response error body', err);
            debugError('cart add failed', { status: response.status, error: err, requestBody: body });
            try {
              window.__fanMiGwpLastStatus = { step: 'failed', status: response.status, error: err, requestBody: body, at: Date.now() };
            } catch (errStatus) {}
            throw new Error((err && err.description) || 'Cart error');
          });
        }
        try {
          window.__fanMiGwpLastStatus = { step: 'success', status: response.status, body: body, at: Date.now() };
        } catch (errStatus) {}
        clearPending();
        clearGwpModalAttrs(qvModal);
        notifyGloboPreorderCartUpdated();
        safeElementDispatch(
          productForm || innerForm,
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              quantity: qty * 2,
              button: addBtn || innerForm,
              variant: (productForm && productForm.currentVariant) || null,
            },
          })
        );
        if (window.theme && window.theme.cartType === 'drawer') {
          safeDocumentDispatch(new CustomEvent('modal:close'));
        }
        if (window.theme && window.theme.cartType === 'page') {
          window.location.href = window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart';
        }
      })
      .catch(function (err) {
        debugLog('add request failed', err && err.message ? err.message : err);
        debugError('bundled add request exception', err && err.message ? err.message : err);
        try {
          window.__fanMiGwpLastStatus = {
            step: 'exception',
            message: err && err.message ? err.message : String(err),
            at: Date.now(),
          };
        } catch (errStatus) {}
        safeDocumentDispatch(new CustomEvent('theme:loading:end'));
        if (addBtn) addBtn.removeAttribute('disabled');
      });

    return true;
  }

  window.addEventListener(
    'click',
    function (e) {
      if (e.__fanMiGwpHandled) return;
      if (eventInQuickViewModal(e)) return;
      var btn = findAddToCartButtonFromEvent(e, { broad: false });
      if (!btn) return;
      try {
        window.__fanMiGwpLastStatus = { step: 'click_seen', at: Date.now() };
      } catch (errStatus) {}
      var productForm = btn.closest('product-form') || null;
      var innerForm = resolveCartAddForm(btn, productForm);
      if (!innerForm) {
        try {
          window.__fanMiGwpLastStatus = { step: 'skip', reason: 'click_no_cart_form', at: Date.now() };
        } catch (errStatus) {}
        return;
      }
      if (!productForm) {
        productForm = innerForm.closest('product-form') || null;
      }
      if (DEBUG_ON) {
        console.log('[fan-mi-gwp] click add-to-cart matched', {
          formId: innerForm.id,
          hasProductForm: !!productForm,
        });
      }
      runGwpBundleAdd(e, innerForm, productForm, btn);
    },
    true
  );

  window.addEventListener(
    'submit',
    function (e) {
      try {
        window.__fanMiGwpLastStatus = { step: 'submit_seen', at: Date.now() };
      } catch (errStatus) {}
      var innerForm = e.target;
      if (!innerForm || innerForm.tagName !== 'FORM') return;
      if (!innerForm.action || innerForm.action.indexOf('/cart/add') === -1) return;
      var productForm = innerForm.closest('product-form');
      runGwpBundleAdd(e, innerForm, productForm, null);
    },
    true
  );

  wrapFetchForCartSync();
})();
